import { render } from "./VendorFiltering.vue?vue&type=template&id=648edf44"
import script from "./VendorFiltering.vue?vue&type=script&lang=js"
export * from "./VendorFiltering.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/bundle-builder/components/VendorFiltering.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "648edf44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('648edf44', __exports__)) {
    api.reload('648edf44', __exports__)
  }
  
  module.hot.accept("./VendorFiltering.vue?vue&type=template&id=648edf44", () => {
    api.rerender('648edf44', render)
  })

}


export default __exports__